import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import VueGoogleApi from 'vue-google-api'     // TODO: switch off of this & remove stylus-loader

Vue.use(VueGoogleApi, {
  apiKey: 'AIzaSyBsb8A-IfygUnYCZRimbc3hyJfOpA15j9Y',                                      // TODO: remove this later
  clientId: '936778917628-cum3jhmd25m2egrgij6l7map4psihm9r.apps.googleusercontent.com',   // TODO: remove this later
  scope: 'https://www.googleapis.com/auth/spreadsheets.readonly',
  discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
